import { PubSubService } from './../service/pubSub.service';
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, OnChanges, OnDestroy, Input, SimpleChanges } from '@angular/core';
import { socialService } from '../services/social/social.service';

/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
    selector: 'bh-missioncontrol',
    templateUrl: './missioncontrol.template.html'
})

export class missioncontrolComponent implements OnInit, OnChanges, OnDestroy {
    @Input('tabChange') tabChange; // current tab selected index
    chartsData: any = {}; // both chart byCategory and byProduct will be part of this object sent by the server
    getDataSub: any; // Subscription variable for pubsub for global dashboard service call timer

    /**
     * socialService got getting mission control data
     * pubsub to subscribe to the timer
     */
    constructor(private socialService: socialService, private pubsub: PubSubService) {
        /**
        *  Subscribe to the getData event
        */
        this.getDataSub = this.pubsub.$sub('getData', (eventObject) => {
            this.getMissionControl();
        });
    }

    /**
     * 1. get mission control data service call
     */
    ngOnInit() {
        this.getMissionControl();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['tabChange'] && changes['tabChange'].currentValue === 0) {
            this.getMissionControl();
        }
    }

    /**
     * Do all the require check and initialization in this method
     * before making the mission control data service call
     */
    getMissionControl() {
        this.chartsData = {};
        this.socialService.getMissionControl().subscribe(result => {
            this.chartsData = result;
        }, error => {
            console.log(error);
        })
    }

    /**
     * 1. unsubscribe the timer before the component is destroyed
    */
    ngOnDestroy() {
        this.getDataSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/missioncontrolComponent/missioncontrol.component.ts